import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <FontAwesomeIcon 
            icon={faExclamationTriangle} 
            className="mx-auto h-16 w-16 text-yellow-500 mb-4" 
          />
          <h1 className="text-6xl font-bold text-gray-900 mb-4">404</h1>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">
            页面未找到
          </h2>
          <p className="text-gray-500 mb-8">
            抱歉，您访问的页面不存在或已被移除。
          </p>
          <div className="space-y-4">
            <Link
              to="/"
              className="inline-flex items-center px-6 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition-colors duration-200"
            >
              <FontAwesomeIcon icon={faHome} className="mr-2" />
              返回首页
            </Link>
            <div className="text-sm text-gray-500">
              或者您可以
              <button
                onClick={() => window.history.back()}
                className="text-blue-600 hover:text-blue-500 ml-1"
              >
                返回上一页
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;